export const NAMESPACE = 'KanBo/currentUser/'
export const SET = NAMESPACE + 'SET_USER'
export const SET_SETTINGS = NAMESPACE + 'SET_SETTINGS'

const initialState = {
  id: null,
  settings: {}
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET:
      return {
        ...state,
        ...action.payload
      }
    case SET_SETTINGS:
      return {
        ...state,
        settings: {
          ...action.payload
        }
      }
    default: return state
  }
}

export function set (data) {
  return {
    type: SET,
    payload: data
  }
}

export function setSettings (payload) {
  return {
    type: SET_SETTINGS,
    payload
  }
}
